import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingMedium, LabelSmall} from "@khanacademy/wonder-blocks-typography";

interface Props {
    /**
     * Header text for the table view.
     */
    title?: string;
    /**
     * Subtitle text for the table view.
     */
    subtitle?: string;
}

/**
 * A component that displays a heading for the table view of Khanmigo chat history.
 * The heading informs users that Khanmigo chats are kept for 60 days and then may be deleted.
 * The component is aligned to the end (right in LTR layouts) and has top margin.
 *
 * @returns A React node containing the heading text wrapped in a styled View
 */
export function TableViewHeading({
    title,
    subtitle = t`Khanmigo chats are kept for 60 days, then may be deleted`,
}: Props): React.ReactNode {
    const headingStyles = [styles.container];
    if (title) {
        headingStyles.push(styles.spaceBetween);
    }
    return (
        <View style={headingStyles}>
            {title && <HeadingMedium>{title}</HeadingMedium>}
            {subtitle && <LabelSmall>{subtitle}</LabelSmall>}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        marginBlockStart: spacing.large_24,
        flexDirection: "row",
        alignItems: "end",
        justifyContent: "flex-end",
    },
    spaceBetween: {
        justifyContent: "space-between",
    },
});
